"use client"

import { Toaster } from "sonner"

// A client module so the icons below are built in the browser. Built in the
// root layout (a server component) they crossed the RSC payload as server
// elements, arrived as deferred references once the layout's row grew past
// React's row limit, and sonner's Toast logged a missing-key warning on every
// toast because it renders the icon inside a children list.
const icons = {
  success: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>,
  error: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>,
  info: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg>,
  warning: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>,
}

const toastOptions = {
  className: 'bg-white! border-0! rounded-2xl! text-sm! font-medium! text-cova-dark! shadow-[0_8px_24px_rgba(0,0,0,0.06),0_2px_8px_rgba(0,0,0,0.03)]!',
  style: { letterSpacing: '-0.01em' },
  classNames: {
    success: 'shadow-[0_8px_24px_rgba(16,185,129,0.12),0_2px_8px_rgba(16,185,129,0.06)]!',
    error: 'shadow-[0_8px_24px_rgba(239,68,68,0.12),0_2px_8px_rgba(239,68,68,0.06)]!',
    info: 'shadow-[0_8px_24px_rgba(59,130,246,0.12),0_2px_8px_rgba(59,130,246,0.06)]!',
    warning: 'shadow-[0_8px_24px_rgba(245,158,11,0.12),0_2px_8px_rgba(245,158,11,0.06)]!',
  },
}

/** The app-wide toaster, mounted once by the root layout. */
export function AppToaster() {
  return <Toaster position="top-right" icons={icons} toastOptions={toastOptions} />
}
